import { ResponseDataGet } from "../../../../models/responseDataGet";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { agroApi } from "../../api";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";

interface ProductRequest {
  id?: number;
  nameKy: string;
  nameRu: string;
  children?: Array<{
    nameKy: string;
    nameRu: string;
  }>;
}

interface ProductResponse extends EntDirectoryInfoName {
  children?: Array<{
    id: number;
    nameKy: string;
    nameRu: string;
  }>;
}

export const ProductionApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllProductList: builder.query<ResponseDataGet<ProductResponse>, EntInitialFilter>({
      query: (filter) => ({
        url: '/departments/chemicalization/hb-product/get-all',
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getProductById: builder.query<ResponseDataTest<ProductResponse>, number>({
      query: (id) => ({
        url: `/departments/chemicalization/hb-product/${id}`,
        method: 'GET'
      })
    }),
    addProducts: builder.mutation<ResponseDataTest<ProductResponse>, ProductRequest>({
      query: (body) => ({
        url: '/departments/chemicalization/hb-product',
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editProducts: builder.mutation<ResponseDataTest<ProductResponse>, ProductRequest>({
      query: (body) => ({
        url: '/departments/chemicalization/hb-product',
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteProducts: builder.mutation<ResponseDataTest<ProductResponse>, number>({
      query: (id) => ({
        url: `/departments/chemicalization/hb-product/${id}`,
        method: 'DELETE',
      }),
    }), 
  }),
  overrideExisting: false,
});

export const {
  useLazyGetAllProductListQuery,
  useAddProductsMutation,
  useEditProductsMutation,
  useDeleteProductsMutation
} = ProductionApi;
